import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { createContext, useContext } from 'react';
import { ApiClient, IApiClient } from '../utils/ApiClient';
import authenticationManager from "../utils/authenticationManager";

/**
 * Context for the API client
 */
export const ApiClientContext = createContext<IApiClient>({} as IApiClient);

/**
 * Provider for the API client
 * @param param0 
 * @returns 
 */
export const ApiClientProvider: React.FC<{ children }> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();

  const client = new ApiClient();

  // Set the token getter method on the ApiClient  
  if(window['auth0Config'].USE_AUTH_0)
    client.setTokenGetter(() => getAccessTokenSilently());
  else
    client.setTokenGetter(() => Promise.resolve(authenticationManager.getAccessToken()));
  

  // Provide the client to the context
  return <ApiClientContext.Provider value={client}>
    {children}
  </ApiClientContext.Provider>;
};

/**
 * Hook to get the API client
 * @returns 
 */
export const useApiClient = () => {
  return useContext(ApiClientContext);
};